/* ee-nav.js - mega menu (desktop) and accordion drawer (mobile) for the EE header.
   Vanilla JS, no libraries. Markup: snippets/ee-mega-menu.liquid + sections/lk-header.liquid.
   Desktop (>=900px): hover-intent or click opens a full-width panel; left tabs switch the right-hand tiles.
   Mobile: the burger opens a side drawer; the same groups are an accordion.
   Keyboard: Enter/Space opens, Esc closes and returns focus, Arrow keys move between items and tabs. */
(function () {
  'use strict';
  var hd = document.querySelector('[data-ee-header]');
  if (!hd || hd.getAttribute('data-ee-ready') === '1') return;
  hd.setAttribute('data-ee-ready', '1');

  var nav = hd.querySelector('[data-ee-nav]');
  var burger = hd.querySelector('[data-ee-burger]');
  var items = [].slice.call(hd.querySelectorAll('[data-ee-item]'));
  var desk = window.matchMedia('(min-width:900px)');
  var openItem = null, openedBy = '', drawerOpen = false, hoverT = 0, leaveT = 0, tabT = 0, lastFocus = null;

  function $(el, sel) { return el ? el.querySelector(sel) : null; }
  function all(el, sel) { return el ? [].slice.call(el.querySelectorAll(sel)) : []; }
  function btnOf(it) { return $(it, '[data-ee-btn]'); }
  function panelOf(it) { return $(it, '[data-ee-panel]'); }
  function tabsOf(p) { return all(p, '[data-ee-tab]'); }


  /* ---- live "Starting from" prices ----
     Small collections are priced by Liquid on the server. Big collections and tag listings are asked for their
     lowest available price (templates/collection.ee-min.liquid, a few bytes); lens families come from the lens
     product's .js feed. Nothing is typed into the theme. Results are cached for ten minutes per tab. */
  var TTL = 600000;
  function money(p) {
    var r = p / 100, n = Math.round(r);
    return '₹' + (Math.abs(r - n) < 0.005 ? n.toLocaleString('en-IN') : r.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  function cached(key) {
    try { var c = JSON.parse(sessionStorage.getItem(key)); if (c && Date.now() - c.t < TTL) return c.v; } catch (e) {}
    return null;
  }
  function keep(key, v) { try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {} }
  function minFor(path) {
    var k = 'ee_min:' + path, c = cached(k);
    if (c !== null) return Promise.resolve(c);
    return fetch(path + (path.indexOf('?') > -1 ? '&' : '?') + 'view=ee-min&sort_by=price-ascending', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { var m = t.match(/\[\[EEMIN:(\d+)\]\]/), v = m ? +m[1] : 0; if (m) keep(k, v); return v; })
      .catch(function () { return 0; });
  }
  var lensP = null;
  function lensPrices() {
    if (lensP) return lensP;
    var c = cached('ee_lens');
    if (c) return (lensP = Promise.resolve(c));
    lensP = fetch('/products/ee-prescription-lenses.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var o = { zero: 0, bluecut: 0, photochromic: 0 };
        ((p && p.variants) || []).forEach(function (v) {
          if (!v.available) return;
          var k = /zero-power/i.test(v.title) ? 'zero' : /^prescription blue-cut/i.test(v.title) ? 'bluecut' : /photochromic/i.test(v.title) ? 'photochromic' : '';
          if (k && (!o[k] || v.price < o[k])) o[k] = v.price;
        });
        keep('ee_lens', o); return o;
      })
      .catch(function () { return { zero: 0, bluecut: 0, photochromic: 0 }; });
    return lensP;
  }
  function show(el, p) {
    if (p > 0) { el.textContent = (el.getAttribute('data-ee-prefix') || '') + money(p); el.hidden = false; }
  }
  function fillPrices(root) {
    all(root, '[data-ee-min]').forEach(function (el) {
      if (el.getAttribute('data-ee-done') || el.textContent.trim()) return;
      el.setAttribute('data-ee-done', '1');
      minFor(el.getAttribute('data-ee-min')).then(function (p) { show(el, p); });
    });
    var l = all(root, '[data-ee-mm-lens]').filter(function (el) { return !el.getAttribute('data-ee-done'); });
    if (l.length) lensPrices().then(function (o) {
      l.forEach(function (el) { el.setAttribute('data-ee-done', '1'); show(el, o[el.getAttribute('data-ee-mm-lens')] || 0); });
    });
  }
  /* page tiles (homepage category rows) after load; header panels the first time they open */
  function pageFill() {
    all(document, '[data-ee-min]').forEach(function (el) {
      if (el.closest('[data-ee-panel]') || el.getAttribute('data-ee-done') || el.textContent.trim()) return;
      el.setAttribute('data-ee-done', '1');
      minFor(el.getAttribute('data-ee-min')).then(function (p) { show(el, p); });
    });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(pageFill, { timeout: 2500 }); else setTimeout(pageFill, 1200);

  /* ---- groups (left tabs on desktop, accordion headings on mobile) ---- */
  function setTab(p, tab, collapse) {
    tabsOf(p).forEach(function (t) {
      var on = t === tab && !collapse;
      t.setAttribute('aria-expanded', on ? 'true' : 'false');
      var pane = document.getElementById(t.getAttribute('aria-controls'));
      if (pane) pane.hidden = !on;
    });
  }

  /* ---- top-level panels ---- */
  function openPanel(it, by, focusFirst) {
    var b = btnOf(it), p = panelOf(it);
    if (!b || !p) return;
    if (openItem && openItem !== it) closePanel(true);
    openItem = it; openedBy = by || 'click';
    b.setAttribute('aria-expanded', 'true');
    p.hidden = false;
    var tabs = tabsOf(p);
    if (tabs.length && (desk.matches || !tabs.some(function (t) { return t.getAttribute('aria-expanded') === 'true'; }))) setTab(p, tabs[0]);
    if (desk.matches) hd.classList.add('ee-open');
    fillPrices(p);
    all(p, 'img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; }); // warm the tiles of the other groups
    if (focusFirst && tabs[0]) tabs[0].focus();
  }
  function closePanel(keepScrim) {
    if (!openItem) return;
    var b = btnOf(openItem), p = panelOf(openItem);
    if (b) b.setAttribute('aria-expanded', 'false');
    if (p) p.hidden = true;
    openItem = null; openedBy = '';
    if (!keepScrim) hd.classList.remove('ee-open');
  }

  /* ---- mobile drawer ---- */
  function focusables() {
    return all(nav, 'a[href],button:not([disabled]),input:not([disabled])').filter(function (el) { return el.offsetParent !== null; });
  }
  function openDrawer(itemId) {
    if (drawerOpen) return;
    drawerOpen = true; lastFocus = document.activeElement;
    hd.classList.add('ee-drawer-open');
    document.documentElement.classList.add('ee-nav-lock');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    if (itemId) {
      var it = items.filter(function (x) { return x.getAttribute('data-ee-id') === itemId; })[0];
      if (it && panelOf(it)) openPanel(it, 'click');
    }
    var c = $(nav, '[data-ee-close]');
    if (c) c.focus();
  }
  function closeDrawer(noFocus) {
    if (!drawerOpen) return;
    drawerOpen = false;
    hd.classList.remove('ee-drawer-open');
    document.documentElement.classList.remove('ee-nav-lock');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (!noFocus) { var f = burger && burger.offsetParent !== null ? burger : lastFocus; if (f && f.focus) f.focus(); }
  }

  /* ---- hover intent (desktop mouse only; touch uses click) ---- */
  items.forEach(function (it) {
    it.addEventListener('pointerenter', function (e) {
      if (!desk.matches || e.pointerType !== 'mouse') return;
      clearTimeout(leaveT); clearTimeout(hoverT);
      if (!panelOf(it)) { leaveT = setTimeout(function () { closePanel(); }, 140); return; }
      hoverT = setTimeout(function () { if (openItem !== it) openPanel(it, 'hover'); }, openItem ? 50 : 110);
    });
    it.addEventListener('pointerleave', function (e) {
      if (!desk.matches || e.pointerType !== 'mouse') return;
      clearTimeout(hoverT);
      leaveT = setTimeout(function () { if (openedBy === 'hover') closePanel(); }, 240);
    });
  });
  hd.addEventListener('pointerover', function (e) {
    var t = e.target.closest && e.target.closest('[data-ee-tab]');
    if (!t || !desk.matches || e.pointerType !== 'mouse') return;
    clearTimeout(tabT);
    tabT = setTimeout(function () { setTab(t.closest('[data-ee-panel]'), t); }, 70);
  });
  hd.addEventListener('pointerout', function (e) {
    if (e.target.closest && e.target.closest('[data-ee-tab]')) clearTimeout(tabT);
  });

  /* ---- clicks ---- */
  hd.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest('[data-ee-btn]');
    if (b) {
      var it = b.closest('[data-ee-item]');
      clearTimeout(hoverT); clearTimeout(leaveT);
      if (openItem === it) {
        if (openedBy === 'hover' && desk.matches) openedBy = 'click'; else closePanel();
      } else openPanel(it, 'click');
      return;
    }
    var tab = t.closest('[data-ee-tab]');
    if (tab) {
      var p = tab.closest('[data-ee-panel]');
      if (desk.matches) setTab(p, tab);
      else setTab(p, tab, tab.getAttribute('aria-expanded') === 'true');
      return;
    }
    if (t.closest('[data-ee-burger]')) { drawerOpen ? closeDrawer() : openDrawer(); return; }
    if (t.closest('[data-ee-close]') || t.closest('[data-ee-scrim]')) {
      if (drawerOpen) closeDrawer(); else closePanel();
      return;
    }
    if (t.closest('[data-ee-close-drawer]')) closeDrawer(true);
  });
  /* "Offers" in the bottom bar opens the drawer on the Offers group */
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-ee-open-menu]');
    if (!o) {
      if (openItem && desk.matches && !hd.contains(e.target)) closePanel();
      return;
    }
    e.preventDefault();
    var id = o.getAttribute('data-ee-open-menu');
    if (drawerOpen) { closeDrawer(true); return; }
    if (desk.matches) { var it = items.filter(function (x) { return x.getAttribute('data-ee-id') === id; })[0]; if (it) openPanel(it, 'click', true); }
    else openDrawer(id);
  });

  /* ---- keyboard ---- */
  hd.addEventListener('keydown', function (e) {
    var k = e.key, t = e.target;
    if (k === 'Tab' && drawerOpen) {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (t === first || !nav.contains(t))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (t === last || !nav.contains(t))) { e.preventDefault(); first.focus(); }
      return;
    }
    if (!desk.matches) return;
    var topEls = items.map(function (x) { return btnOf(x) || $(x, 'a'); });
    var ti = topEls.indexOf(t);
    if (ti > -1) {
      if (k === 'ArrowRight' || k === 'ArrowLeft') {
        e.preventDefault();
        var n = topEls[(ti + (k === 'ArrowRight' ? 1 : topEls.length - 1)) % topEls.length]; if (n) n.focus();
      } else if (k === 'ArrowDown' && btnOf(items[ti]) === t) {
        e.preventDefault(); openPanel(items[ti], 'click', true);
      }
      return;
    }
    if (t.hasAttribute && t.hasAttribute('data-ee-tab')) {
      var tabs = tabsOf(t.closest('[data-ee-panel]')), i = tabs.indexOf(t), nx = -1;
      if (k === 'ArrowDown') nx = (i + 1) % tabs.length;
      else if (k === 'ArrowUp') nx = (i + tabs.length - 1) % tabs.length;
      else if (k === 'Home') nx = 0;
      else if (k === 'End') nx = tabs.length - 1;
      else if (k === 'ArrowRight') {
        var a = $(document.getElementById(t.getAttribute('aria-controls')), 'a'); if (a) { e.preventDefault(); a.focus(); }
        return;
      }
      if (nx > -1) { e.preventDefault(); tabs[nx].focus(); setTab(t.closest('[data-ee-panel]'), tabs[nx]); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawerOpen) { closeDrawer(); return; }
    if (openItem) { var b = btnOf(openItem); closePanel(); if (b) b.focus(); }
  });
  hd.addEventListener('focusout', function (e) {
    if (!desk.matches || !openItem || !e.relatedTarget) return;
    if (!openItem.contains(e.relatedTarget)) closePanel();
  });

  /* ---- breakpoint change: reset everything ---- */
  function reset() {
    closeDrawer(true); closePanel();
    all(hd, '[data-ee-panel]').forEach(function (p) { p.hidden = true; });
  }
  if (desk.addEventListener) desk.addEventListener('change', reset); else if (desk.addListener) desk.addListener(reset);
  window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
})();
